<script>
export default {
  name: 'pop',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    itemObj: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      showPopup: this.value,
    }
  },
  watch:{
    value(val) {
      this.showPopup = val;
    },
    showPopup(val) {
      this.$emit('input', val);
    },
  },
  methods: {
    onCancel(){
      this.showPopup = false;
    },
    onConfirm(values){
      this.itemObj.value = values.label;
      this.$emit('submit', this.itemObj);
      this.onCancel();
    }
  }
}
</script>
<template>
  <van-popup
      v-model="showPopup"
      round
      position="bottom"
  >
    <van-picker
        v-if="itemObj.params&&itemObj.params.customDesign"
        show-toolbar
        :title="itemObj.name"
        :columns="itemObj.params.customDesign.values"
        value-key="label"
        @confirm="onConfirm"
        @cancel="onCancel"
    />
  </van-popup>
</template>
<style scoped lang="scss">
</style>